<template>
    <nav id="menubar-area">
        <div id="menubar-items-area">
            <router-link class="menubar-item link" v-bind:to="getLinkParamsToHome()">
                <div class="menubar-text">HOME</div>
            </router-link>
            <router-link class="menubar-item link" v-bind:to="getLinkParamsToBlog()">
                <div class="menubar-text">BLOG</div>
            </router-link>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "MenuBarComponent",
        setup() {
            //-----------------------------------------
            // メソッド（APIコールなし・テンプレート内使用あり）
            //-----------------------------------------
            function getLinkParamsToHome() {
                return {name: "home"};
            }

            function getLinkParamsToBlog() {
                return {name: "blog"};
            }

            // -----------------------------------------
            // テンプレートへの返り値
            // -----------------------------------------
            return {
                getLinkParamsToHome, getLinkParamsToBlog
            };
        }
    };
</script>

<style scoped lang="scss">
    @import "@/scss/components/menuBar.scss";
</style>